import { render, staticRenderFns } from "./SettingsGeneral.vue?vue&type=template&id=28c6ea6d"
import script from "./SettingsGeneral.vue?vue&type=script&lang=js"
export * from "./SettingsGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports